import { Autocomplete, TextField } from "@mui/material";
import { styled, SxProps } from "@mui/material/styles";
import { useField, useFormikContext } from "formik";
import { FC, useMemo } from "react";
import { IOption } from "../../interfaces/Utils";
import { isExists } from "../../utils";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#0063cc",
  },
  "& label.Mui-disabled": {
    color:
      localStorage.getItem("dark") === "true"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#0063cc",
  },
  ".MuiOutlinedInput-input.Mui-disabled": {
    textFillColor:
      localStorage.getItem("dark") === "true"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#e5e5e5",
    },
    "&.Mui-disabled": {
      color:
        localStorage.getItem("dark") === "true"
          ? "rgba(255, 255, 255, 0.38)"
          : "rgba(0, 0, 0, 0.38)",
      fieldset: {
        borderColor:
          localStorage.getItem("dark") === "true"
            ? "rgba(255, 255, 255, 0.38)"
            : "rgba(0, 0, 0, 0.38)",
      },
    },
    "&:hover fieldset": {
      borderColor: "#0063cc",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#0063cc",
    },
  },
});

interface IAutocompleteInput {
  name: string;
  options: IOption[] | any;
  label: string;
  placeholder?: string;
  multiple?: boolean;
  disabled?: boolean;
  value?: any;
  groupBy?: any;
  disableClearable?: boolean;
  readOnly?: boolean;
  onChange?: (event: any, newValue: any) => void;
  style?: SxProps;
  info?: string;
  optionDisabled?: any;
}

const AutocompleteInput: FC<IAutocompleteInput> = ({
  name,
  options,
  label,
  value,
  disabled,
  groupBy,
  disableClearable,
  readOnly,
  onChange,
  style,
  info,
  optionDisabled,
  ...otherProps
}) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  const configSelect = {
    ...field,
    ...otherProps,
    error: "false",
    helpertext: "",
  };

  if (meta && meta.error) {
    configSelect.error = "true";
    configSelect.helpertext = meta.error;
  }

  return useMemo(
    () => (
      <Autocomplete
        isOptionEqualToValue={(_option, _value) => true}
        value={
          isExists(field.value)
            ? options.find((option: any) => option.value === field.value)
            : ""
        }
        id={name}
        disabled={disabled}
        getOptionDisabled={(option: any) =>
          option.value ===
          optionDisabled?.find((item: any) => item === option.value)
        }
        onChange={
          onChange
            ? onChange
            : (_event, newValue: any) =>
                newValue
                  ? setFieldValue(field.name, newValue.value)
                  : setFieldValue(field.name, "")
        }
        groupBy={groupBy}
        options={options}
        disableClearable={disableClearable}
        readOnly={readOnly}
        sx={style}
        fullWidth
        renderInput={(params) => (
          <CssTextField
            {...params}
            helperText={configSelect.helpertext}
            error={Boolean(meta.error)}
            label={label}
          />
        )}
      />
    ),
    [field.value, meta.error, options, disabled, optionDisabled]
  );
};

export default AutocompleteInput;
